import React from "react";

interface Options {
    center?: boolean;
}

export default function useScrollToActive(
    containerRef: React.MutableRefObject<Element>,
    options?: Options,
) {
    const { center } = options || {};
    const activeElement = React.useRef<Element>();

    // On first render scroll to immediately.
    React.useEffect(() => {
        const el = containerRef.current?.querySelector("*[data-active=true]");
        if (!el) return;
        if (typeof el.scrollIntoView === "function") {
            el.scrollIntoView({
                block: center ? "center" : undefined,
            });
        }
        activeElement.current = el;
    }, []);

    // On subsequent renders smoothly scroll.
    React.useEffect(() => {
        const el = containerRef.current?.querySelector("*[data-active=true]");
        if (!el) return;
        if (el === activeElement.current) return;
        if (typeof el.scrollIntoView === "function") {
            el.scrollIntoView({
                behavior: activeElement.current ? "smooth" : "auto",
                block: center ? "center" : undefined,
            });
        }
        activeElement.current = el;
    }, [center]);
}
